import React from "react";
import ResetPasswordForm from "../../components/User/ResetPassword";

const ResetPassword = () => {
  return <ResetPasswordForm />;
};

export default ResetPassword;
